
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35117',
  depVersions: {
  "documents-public-ui": "static-1.35117",
  "atom": "static-1.5332",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2745",
  "client-types": "static-1.490",
  "cssUtils": "static-1.870",
  "customer-data-filters-ui": "static-1.40759",
  "customer-data-objects": "static-1.7936",
  "customer-data-property-utils": "static-1.8347",
  "documents-lib": "static-1.35122",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.360",
  "FormsCommonComponents": "static-1.86478",
  "FormUrlGenerator": "static-2.4974",
  "foundations-theming-specialty": "static-1.2420",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5844",
  "hs-test-utils": "static-1.8275",
  "hub-http": "static-1.6461",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12039",
  "HubStyleTokens": "static-2.11732",
  "I18n": "static-7.1661",
  "icons": "static-2.674",
  "jasmine-immutable": "static-1.3271",
  "jasmine-runner": "static-1.6697",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7400",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3145",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5642",
  "quartz": "static-1.7367",
  "react": "static-7.191",
  "react-dlb": "static-1.85",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.6",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5517",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8430",
  "reference-resolvers-lite": "static-1.8348",
  "reporting-data": "static-1.68583",
  "reporting-reports": "static-1.68261",
  "reporting-snowflake": "static-1.57201",
  "reporting-testing-lib": "static-1.10516",
  "reporting-visualizations": "static-1.60659",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9196",
  "sanitize": "static-1.4723",
  "sanitize-text": "static-1.8398",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1994",
  "signup-constants": "static-1.19496",
  "signup-ui-url-generator": "static-2.8307",
  "StyleGuideUI": "static-3.495",
  "superstore": "static-1.5006",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5004",
  "ui-addon-form-validation": "static-1.11234",
  "ui-asset-management-lib": "static-1.11344",
  "ui-images": "static-2.1229",
  "UIComponents": "static-3.8678",
  "usage-tracker": "static-1.7604",
  "usage-tracker-container": "static-1.7594",
  "usage-tracker-core": "static-1.7454",
  "viral-links-lib": "static-1.7322",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9905",
  "foundations-components": "static-1.8388",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1145",
  "quartz-core": "static-1.6586",
  "quick-fetch": "static-1.4094",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4910",
  "ui-addon-i18n": "static-1.11394",
  "ui-addon-upgrades": "static-9.18320",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3579",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3644",
  "quartz-webpack": "static-1.3591",
  "foundations-assets": "static-1.5124",
  "foundations-theming": "static-1.4704",
  "hub-http-shared-msw-handlers": "static-1.10528",
  "hubspotter-http": "static-1.4826",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7497",
  "crm-message-bus": "static-1.43642",
  "customer-data-filters-ui-msw-helpers": "static-1.23194",
  "customer-data-objects-ui-components": "static-1.13278",
  "customer-data-reference-ui-components": "static-1.13428",
  "customer-data-ui-utilities": "static-1.10074",
  "events-data-lib": "static-1.490",
  "framework-builder-read-service-client": "static-1.4183",
  "hs-resources": "static-1.438",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4019",
  "multi-account-reference-resolvers": "static-1.1244",
  "onboarding-scopes": "static-1.6705",
  "onboarding-tours": "static-1.17040",
  "pulse": "static-1.875",
  "reporting-datasets-permissions-lib": "static-1.14367",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2470",
  "trellis-components": "static-1.2489",
  "trellis-theming": "static-1.1209",
  "ui-addon-teams": "static-1.21854",
  "quartz-auth": "static-1.1042",
  "ui-business-units-lib": "static-1.9331",
  "usage-tracker-session-replay": "static-1.5290",
  "ai-components-ui-library": "static-1.9583",
  "ContentUtils": "static-1.69056",
  "customer-data-properties": "static-1.52430",
  "forms-ai-lib": "static-1.4689",
  "forms-utils-lib": "static-1.13020",
  "foundations-components-test-utils": "static-1.5871",
  "react-dnd-compat": "static-1.4864",
  "react-tinymce": "static-1.55875",
  "tinymce-config": "static-2.55001",
  "ui-gdpr-components": "static-1.10602",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3689",
  "HeadJS": "static-2.789",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3386",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.256",
  "ui-fonts": "static-1.994",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4567",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1032",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1792",
  "external-options-client-types": "static-1.4302",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7142",
  "quartz-i18n": "static-1.1042",
  "frontend-preferences-client": "static-1.8175",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3949",
  "reporting-client-types": "static-1.2652",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26074",
  "hubspot-apollo-client": "static-1.5126",
  "foundations-components-legacy": "static-1.1413",
  "quartz-routing": "static-1.797",
  "hs-story-utils": "static-1.9675",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.481",
  "seat-types-lib": "static-1.613",
  "timezone-utils": "static-2.5496",
  "react-create-root-preference": "static-1.60",
  "bend-plugin-foundations-components": "static-1.4657",
  "floating-ui": "static-1.61",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-test": "static-1.1042",
  "quartz-tracking": "static-1.746",
  "bend-plugin-chirp-manifest": "static-1.320",
  "chirp-fetch": "static-1.2139",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6283",
  "salesImages": "static-1.530",
  "ts-schema": "static-1.4256",
  "bender-build-tools": "static-1.3358",
  "bend-plugin-foundations-theming": "static-1.3187",
  "restore-request-side-panel-lib": "static-1.1555",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4904",
  "conditional-properties-service-client": "static-1.3977",
  "crm-pipelines-api-client-types": "static-1.4310",
  "event-emitter": "static-1.1202",
  "fdsr-migration-layer": "static-1.261",
  "multi-currency-client-types": "static-1.3870",
  "getting-started-shared-tasks": "static-1.19114",
  "growth-data-modal": "static-1.5820",
  "growth-onboarding-confetti": "static-1.3309",
  "growth-onboarding-next-action-utils": "static-1.2596",
  "navigation-components": "static-1.18716",
  "onboarding-tours-client": "static-1.5254",
  "onboarding-tours-utils": "static-1.1106",
  "ui-shepherd-react": "static-3.10511",
  "ui-shepherd-tracker": "static-1.7892",
  "ui-universal-auth": "static-1.9289",
  "user-context": "static-1.5360",
  "bend-plugin-pulse": "static-1.378",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10526",
  "magpie-lib": "static-1.5719",
  "navigation-messaging": "static-1.8043",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22638",
  "copilot-toolkit": "static-1.11744",
  "cms-field-types": "static-1.5063",
  "content-icons-ui": "static-1.2312",
  "integrations-lib": "static-1.16928",
  "calling-global-api": "static-1.65372",
  "calling-internal-common": "static-1.31564",
  "calling-lifecycle-internal": "static-1.66754",
  "calling-lifecycle-messages": "static-1.59048",
  "commerce-products-lib": "static-1.10408",
  "crm-index-visualization-core": "static-1.4476",
  "crm-links": "static-1.6570",
  "customer-data-properties-shared-msw-handlers": "static-1.9855",
  "file-manager-components": "static-1.24364",
  "formula-editor": "static-1.14675",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4387",
  "meetings-icalendar-utils-lib": "static-1.884",
  "object-builder-ui-client": "static-1.49532",
  "pipeline-validation-client-types": "static-1.4145",
  "property-value-citations": "static-1.3044",
  "smart-property-lib": "static-1.8167",
  "tiered-pricing": "static-1.1860",
  "trial-components-library": "static-1.14024",
  "topics-actions-lib": "static-1.409",
  "ui-addon-iframeable": "static-1.9324",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20237",
  "tinymce-themes": "static-1.56971",
  "data-token-picker": "static-1.16814",
  "hub-http-contrib": "static-1.3287",
  "interframe": "static-3.5005",
  "tinymce-data": "static-1.41086",
  "tinymce-plugins": "static-1.58115",
  "ui-addon-sales-email": "static-1.5462",
  "framework-data-schema-quick-fetch": "static-1.7047",
  "ui-addon-opt": "static-4.8611",
  "hubspot-apollo-cache": "static-1.585",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.423",
  "purchase-motions-api": "static-1.6286",
  "onboarding-data-sync-lib": "static-1.2410",
  "growth-onboarding-next-action-components": "static-1.2624",
  "user-context-client": "static-1.4755",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5179",
  "nest": "static-1.484",
  "reactive-lib": "static-1.969",
  "simple-logging-lib": "static-1.3297",
  "unified-auth-core-lib": "static-1.1085",
  "getting-started-shared-tasks-store": "static-1.18232",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1571",
  "integrations-error-boundary-lib": "static-1.14343",
  "integrations-tracking-lib": "static-1.5856",
  "native-integrations-shared-strings": "static-1.8025",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10614",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.803",
  "calling-error-reporting": "static-1.31571",
  "shared-worker-versioning": "static-1.11289",
  "calling-usage-tracker": "static-1.6786",
  "voice-sms-access-library": "static-1.1911",
  "customer-data-tracking": "static-1.7130",
  "commerce-permissions": "static-1.1025",
  "products-iframe-lib": "static-1.8498",
  "products-ui-components-shared-msw-handlers": "static-1.10910",
  "crm-index-associations-lib": "static-1.6690",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10611",
  "sales-views-client-types": "static-1.4505",
  "location-customization-utils-lib": "static-1.9991",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4399",
  "video-components-external": "static-1.12057",
  "video-data-lib": "static-1.35715",
  "bark-lib": "static-1.16754",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6137",
  "react-codemirror": "static-1.10889",
  "data-agent-kit": "static-1.574",
  "feedback-loader": "static-1.29735",
  "fsm": "static-1.3987",
  "policy-lib": "static-1.7042",
  "react-colorpicker": "static-2.10455",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10674",
  "embedded-academy-lib": "static-1.15346",
  "hubs-service-types": "static-1.1506",
  "FileManagerLib": "static-1.40004",
  "NamespacedHubStyle": "static-2.9225",
  "FileManagerCore": "static-1.39863",
  "content-assistance-lib": "static-1.8132",
  "layout-dnd-components": "static-1.12892",
  "layout-dnd-utils": "static-1.11867",
  "ui-addon-emoji-picker": "static-1.10133",
  "ui-brand-identity-lib": "static-1.16221",
  "InboxConnectUtils": "static-4.15459",
  "meetings-connect-utils-lib": "static-1.7856",
  "breeze-engine-chat-components": "static-1.549",
  "breeze-engine-core": "static-1.849",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3257",
  "adobe-sign-auth-lib": "static-1.355",
  "ads-unified-auth-lib": "static-1.1048",
  "google-sheets-integration-lib": "static-1.930",
  "microsoft-drive-auth-lib": "static-1.22",
  "surveymonkey-integration-lib": "static-1.375",
  "slack-ui-library": "static-1.10645",
  "calling-orchestration-schema": "static-1.36688",
  "crm-record-cards-service-types": "static-1.3758",
  "content-media-composition-data-lib": "static-1.13113",
  "content-media-compositions": "static-2.17120",
  "media-bridge-lib": "static-1.19336",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16266",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4758",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14806",
  "audio-components": "static-1.6274",
  "FileManagerImages": "static-1.37515",
  "video-components": "static-1.14059",
  "breeze-artifacts-sdk": "static-1.190",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4781",
  "video-embed": "static-1.36549",
  "ui-addon-video-player": "static-1.8953",
  "ui-coaching-tips": "static-1.29214",
  "ContentData": "static-1.69131",
  "layout-data-lib": "static-1.10192",
  "academy-service-client": "static-1.3937",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4653",
  "trellis-ecosystem": "static-1.7558",
  "ui-addon-react-router-dom": "static-1.9782",
  "wootric-nps": "static-1.7162",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4409",
  "growth-onboarding-feedback-components": "static-1.6831",
  "advanced-menus-core": "static-1.15511",
  "advanced-menus-lib": "static-1.12392",
  "ExportDialog": "static-6.10628",
  "ui-memberships-settings-lib": "static-1.34717",
  "marketplace-ui-apps-core": "static-1.19135",
  "marketplace-ui-common": "static-1.20603",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15510",
  "simple-menus-lib": "static-1.17027",
  "developer-experience-shared-components": "static-1.10748",
  "immutable-less": "static-1.4899",
  "marketplace-ui-client-types": "static-1.18010",
  "ui-addon-integrations-directory-panel": "static-2.8274",
  "ui-extensibility-client-types": "static-1.4168",
  "ai-settings-ui-library": "static-1.8256",
  "nav-meta": "static-1.30353",
  "ui-product-approvals-common": "static-1.883",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4503",
  "simple-data-table": "static-1.3437"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35117",
  "atom": "/atom/static-1.5332",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2745",
  "client-types": "/client-types/static-1.490",
  "cssUtils": "/cssUtils/static-1.870",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40759",
  "customer-data-objects": "/customer-data-objects/static-1.7936",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8347",
  "documents-lib": "/documents-lib/static-1.35122",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.360",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4974",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2420",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5844",
  "hs-test-utils": "/hs-test-utils/static-1.8275",
  "hub-http": "/hub-http/static-1.6461",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12039",
  "HubStyleTokens": "/HubStyleTokens/static-2.11732",
  "I18n": "/I18n/static-7.1661",
  "icons": "/icons/static-2.674",
  "jasmine-immutable": "/jasmine-immutable/static-1.3271",
  "jasmine-runner": "/jasmine-runner/static-1.6697",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7400",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3145",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5642",
  "quartz": "/quartz/static-1.7367",
  "react": "/react/static-7.191",
  "react-dlb": "/react-dlb/static-1.85",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.6",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5517",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8430",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8348",
  "reporting-data": "/reporting-data/static-1.68583",
  "reporting-reports": "/reporting-reports/static-1.68261",
  "reporting-snowflake": "/reporting-snowflake/static-1.57201",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10516",
  "reporting-visualizations": "/reporting-visualizations/static-1.60659",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9196",
  "sanitize": "/sanitize/static-1.4723",
  "sanitize-text": "/sanitize-text/static-1.8398",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1994",
  "signup-constants": "/signup-constants/static-1.19496",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8307",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "superstore": "/superstore/static-1.5006",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5004",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11234",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11344",
  "ui-images": "/ui-images/static-2.1229",
  "UIComponents": "/UIComponents/static-3.8678",
  "usage-tracker": "/usage-tracker/static-1.7604",
  "usage-tracker-container": "/usage-tracker-container/static-1.7594",
  "usage-tracker-core": "/usage-tracker-core/static-1.7454",
  "viral-links-lib": "/viral-links-lib/static-1.7322",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9905",
  "foundations-components": "/foundations-components/static-1.8388",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1145",
  "quartz-core": "/quartz-core/static-1.6586",
  "quick-fetch": "/quick-fetch/static-1.4094",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4910",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11394",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18320",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3579",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3644",
  "quartz-webpack": "/quartz-webpack/static-1.3591",
  "foundations-assets": "/foundations-assets/static-1.5124",
  "foundations-theming": "/foundations-theming/static-1.4704",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10528",
  "hubspotter-http": "/hubspotter-http/static-1.4826",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7497",
  "crm-message-bus": "/crm-message-bus/static-1.43642",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23194",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13278",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13428",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10074",
  "events-data-lib": "/events-data-lib/static-1.490",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4183",
  "hs-resources": "/hs-resources/static-1.438",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4019",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1244",
  "onboarding-scopes": "/onboarding-scopes/static-1.6705",
  "onboarding-tours": "/onboarding-tours/static-1.17040",
  "pulse": "/pulse/static-1.875",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14367",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2470",
  "trellis-components": "/trellis-components/static-1.2489",
  "trellis-theming": "/trellis-theming/static-1.1209",
  "ui-addon-teams": "/ui-addon-teams/static-1.21854",
  "quartz-auth": "/quartz-auth/static-1.1042",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9331",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5290",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9583",
  "ContentUtils": "/ContentUtils/static-1.69056",
  "customer-data-properties": "/customer-data-properties/static-1.52430",
  "forms-ai-lib": "/forms-ai-lib/static-1.4689",
  "forms-utils-lib": "/forms-utils-lib/static-1.13020",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5871",
  "react-dnd-compat": "/react-dnd-compat/static-1.4864",
  "react-tinymce": "/react-tinymce/static-1.55875",
  "tinymce-config": "/tinymce-config/static-2.55001",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10602",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3689",
  "HeadJS": "/HeadJS/static-2.789",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3386",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.256",
  "ui-fonts": "/ui-fonts/static-1.994",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4567",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1032",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1792",
  "external-options-client-types": "/external-options-client-types/static-1.4302",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7142",
  "quartz-i18n": "/quartz-i18n/static-1.1042",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8175",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3949",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26074",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5126",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1413",
  "quartz-routing": "/quartz-routing/static-1.797",
  "hs-story-utils": "/hs-story-utils/static-1.9675",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.481",
  "seat-types-lib": "/seat-types-lib/static-1.613",
  "timezone-utils": "/timezone-utils/static-2.5496",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4657",
  "floating-ui": "/floating-ui/static-1.61",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-test": "/quartz-test/static-1.1042",
  "quartz-tracking": "/quartz-tracking/static-1.746",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.320",
  "chirp-fetch": "/chirp-fetch/static-1.2139",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6283",
  "salesImages": "/salesImages/static-1.530",
  "ts-schema": "/ts-schema/static-1.4256",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3187",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1555",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4904",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3977",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4310",
  "event-emitter": "/event-emitter/static-1.1202",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.261",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3870",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19114",
  "growth-data-modal": "/growth-data-modal/static-1.5820",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3309",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2596",
  "navigation-components": "/navigation-components/static-1.18716",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5254",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1106",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10511",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7892",
  "ui-universal-auth": "/ui-universal-auth/static-1.9289",
  "user-context": "/user-context/static-1.5360",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.378",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10526",
  "magpie-lib": "/magpie-lib/static-1.5719",
  "navigation-messaging": "/navigation-messaging/static-1.8043",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22638",
  "copilot-toolkit": "/copilot-toolkit/static-1.11744",
  "cms-field-types": "/cms-field-types/static-1.5063",
  "content-icons-ui": "/content-icons-ui/static-1.2312",
  "integrations-lib": "/integrations-lib/static-1.16928",
  "calling-global-api": "/calling-global-api/static-1.65372",
  "calling-internal-common": "/calling-internal-common/static-1.31564",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66754",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59048",
  "commerce-products-lib": "/commerce-products-lib/static-1.10408",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4476",
  "crm-links": "/crm-links/static-1.6570",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9855",
  "file-manager-components": "/file-manager-components/static-1.24364",
  "formula-editor": "/formula-editor/static-1.14675",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4387",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.884",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49532",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4145",
  "property-value-citations": "/property-value-citations/static-1.3044",
  "smart-property-lib": "/smart-property-lib/static-1.8167",
  "tiered-pricing": "/tiered-pricing/static-1.1860",
  "trial-components-library": "/trial-components-library/static-1.14024",
  "topics-actions-lib": "/topics-actions-lib/static-1.409",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9324",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20237",
  "tinymce-themes": "/tinymce-themes/static-1.56971",
  "data-token-picker": "/data-token-picker/static-1.16814",
  "hub-http-contrib": "/hub-http-contrib/static-1.3287",
  "interframe": "/interframe/static-3.5005",
  "tinymce-data": "/tinymce-data/static-1.41086",
  "tinymce-plugins": "/tinymce-plugins/static-1.58115",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5462",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7047",
  "ui-addon-opt": "/ui-addon-opt/static-4.8611",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.585",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.423",
  "purchase-motions-api": "/purchase-motions-api/static-1.6286",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2410",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2624",
  "user-context-client": "/user-context-client/static-1.4755",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5179",
  "nest": "/nest/static-1.484",
  "reactive-lib": "/reactive-lib/static-1.969",
  "simple-logging-lib": "/simple-logging-lib/static-1.3297",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1085",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18232",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1571",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14343",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5856",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8025",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10614",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.803",
  "calling-error-reporting": "/calling-error-reporting/static-1.31571",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11289",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6786",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1911",
  "customer-data-tracking": "/customer-data-tracking/static-1.7130",
  "commerce-permissions": "/commerce-permissions/static-1.1025",
  "products-iframe-lib": "/products-iframe-lib/static-1.8498",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10910",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6690",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10611",
  "sales-views-client-types": "/sales-views-client-types/static-1.4505",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9991",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4399",
  "video-components-external": "/video-components-external/static-1.12057",
  "video-data-lib": "/video-data-lib/static-1.35715",
  "bark-lib": "/bark-lib/static-1.16754",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6137",
  "react-codemirror": "/react-codemirror/static-1.10889",
  "data-agent-kit": "/data-agent-kit/static-1.574",
  "feedback-loader": "/feedback-loader/static-1.29735",
  "fsm": "/fsm/static-1.3987",
  "policy-lib": "/policy-lib/static-1.7042",
  "react-colorpicker": "/react-colorpicker/static-2.10455",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10674",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15346",
  "hubs-service-types": "/hubs-service-types/static-1.1506",
  "FileManagerLib": "/FileManagerLib/static-1.40004",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9225",
  "FileManagerCore": "/FileManagerCore/static-1.39863",
  "content-assistance-lib": "/content-assistance-lib/static-1.8132",
  "layout-dnd-components": "/layout-dnd-components/static-1.12892",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11867",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10133",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16221",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15459",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7856",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.549",
  "breeze-engine-core": "/breeze-engine-core/static-1.849",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3257",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.355",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1048",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.930",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.22",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.375",
  "slack-ui-library": "/slack-ui-library/static-1.10645",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36688",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3758",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13113",
  "content-media-compositions": "/content-media-compositions/static-2.17120",
  "media-bridge-lib": "/media-bridge-lib/static-1.19336",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16266",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4758",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14806",
  "audio-components": "/audio-components/static-1.6274",
  "FileManagerImages": "/FileManagerImages/static-1.37515",
  "video-components": "/video-components/static-1.14059",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.190",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4781",
  "video-embed": "/video-embed/static-1.36549",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8953",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29214",
  "ContentData": "/ContentData/static-1.69131",
  "layout-data-lib": "/layout-data-lib/static-1.10192",
  "academy-service-client": "/academy-service-client/static-1.3937",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4653",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7558",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9782",
  "wootric-nps": "/wootric-nps/static-1.7162",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4409",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6831",
  "advanced-menus-core": "/advanced-menus-core/static-1.15511",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12392",
  "ExportDialog": "/ExportDialog/static-6.10628",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34717",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19135",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20603",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15510",
  "simple-menus-lib": "/simple-menus-lib/static-1.17027",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10748",
  "immutable-less": "/immutable-less/static-1.4899",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18010",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8274",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4168",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8256",
  "nav-meta": "/nav-meta/static-1.30353",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.883",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4503",
  "simple-data-table": "/simple-data-table/static-1.3437"
}
};
